import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { AppThemeProvider } from './AppThemeProvider';
import Layout from './common/components/global/Layout';
import AuthRoute from './common/components/global/route/AuthRoute';
import MyPrivateRoute from './common/components/global/route/MyPrivateRoute';
import { AuthContext } from './common/context/auth';
import { PageProvider } from './common/context/pages';
import AccountEdit from './common/pages/accountEdit';
import AccountMembersEdit from './common/pages/accountMembersEdit';
import Accounts from './common/pages/accounts';
import Auth from './common/pages/auth';
import DnsZonesComponent from './common/pages/dnsZones/DnsZonesComponent';
import ForgotPassword from './common/pages/forgotPassword';
import ResetPasswordDone from './common/pages/forgotPassword/done';
import ResetPassword from './common/pages/forgotPassword/resetPassword';
import JoinAccountDisabledToken from './common/pages/joinAccount/disabledToken';
import JoinAccountFirst from './common/pages/joinAccount/firstStep';
import JoinAccountSecond from './common/pages/joinAccount/secondStep';
import L7Protection from './common/pages/l7Protection';
import MyProfile from './common/pages/myProfile';
import NotFound from './common/pages/notFound';
import Users from './common/pages/users';
import routes from './common/routes';
import { scheme } from './common/scheme';
// import { createMuiTheme, MuiThemeProvider } from '@mui/material';
import { GlobalCss } from './common/theme/styles';
import ThemeCustomization from '@/common/theme';
import React, { useContext, useEffect } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import useInterval from 'use-interval';
import {
  MonitoringObjectsView,
  ProtectedProfilesView,
} from '@/common/pages/networkProtectionV2/pages/index.js';

const App = () => {
  // const theme = createMuiTheme(scheme());
  const { user } = useContext(AuthContext);
  const params = useLocation();
  const searchParams = new URLSearchParams(params.search);
  const token = searchParams.get('tokenByEmployee');
  const navigate = useNavigate();
  const context = useContext(AuthContext);

  const startTime = new Date();
  useInterval(
    () => {
      const curTime = new Date();
      const delta = curTime.getTime() - startTime.getTime();
      if (delta > 82800000) {
        context.logout();
      }
    },
    user ? 1200000 : null
  );

  useEffect(() => {
    if (token) {
      context.login(token);
      navigate('/my-profile/0');
    }
  }, []);

  return (
    <ThemeCustomization>
      <GlobalCss />
      <AppThemeProvider>
        <Layout>
          <PageProvider>
            <Routes>
              <Route
                exact
                path={routes.auth}
                element={
                  <AuthRoute>
                    <Auth />
                  </AuthRoute>
                }
              />
              <Route
                exact
                path={routes.joinAccountFirst}
                element={
                  <AuthRoute>
                    <JoinAccountFirst />
                  </AuthRoute>
                }
              />
              <Route
                exact
                path={routes.joinAccountSecond}
                element={
                  <AuthRoute>
                    <JoinAccountSecond />
                  </AuthRoute>
                }
              />
              <Route
                exact
                path={routes.joinAccountDisabled}
                element={
                  <AuthRoute>
                    <JoinAccountDisabledToken />
                  </AuthRoute>
                }
              />
              <Route
                exact
                path={routes.forgotPassword}
                element={
                  <AuthRoute>
                    <ForgotPassword />
                  </AuthRoute>
                }
              />
              <Route
                exact
                path={routes.resetPassword}
                element={
                  <AuthRoute>
                    <ResetPassword />
                  </AuthRoute>
                }
              />
              <Route
                exact
                path={routes.resetPasswordDone}
                element={
                  <AuthRoute>
                    <ResetPasswordDone />
                  </AuthRoute>
                }
              />
              <Route
                exact
                path={routes.myProfile}
                element={
                  <MyPrivateRoute>
                    <MyProfile />
                  </MyPrivateRoute>
                }
              />
              <Route
                exact
                path={routes.accounts}
                element={
                  <MyPrivateRoute>
                    <Accounts />
                  </MyPrivateRoute>
                }
              />
              <Route
                exact
                path={routes.accountEditUser}
                element={
                  <MyPrivateRoute>
                    <AccountEdit />
                  </MyPrivateRoute>
                }
              />
              <Route
                exact
                path={routes.accountAccessGroup}
                element={
                  <MyPrivateRoute>
                    <AccountEdit />
                  </MyPrivateRoute>
                }
              />
              <Route
                exact
                path={routes.accountEdit}
                element={
                  <MyPrivateRoute>
                    <AccountEdit />
                  </MyPrivateRoute>
                }
              />
              <Route
                exact
                path={routes.dnsHosting}
                element={
                  <MyPrivateRoute>
                    <AccountEdit />
                  </MyPrivateRoute>
                }
              />
              <Route
                exact
                path={routes.accountMembersEdit}
                element={
                  <MyPrivateRoute>
                    <AccountMembersEdit />
                  </MyPrivateRoute>
                }
              />
              <Route
                exact
                path={routes.users}
                element={
                  <MyPrivateRoute>
                    <Users />
                  </MyPrivateRoute>
                }
              />
              <Route
                exact
                path={routes.appProtection}
                element={
                  <MyPrivateRoute>
                    <L7Protection />
                  </MyPrivateRoute>
                }
              />
              <Route
                exact
                path={routes.dnsZones}
                element={
                  <MyPrivateRoute>
                    <DnsZonesComponent />
                  </MyPrivateRoute>
                }
              />
              <Route exact path={routes.netProtectionV2} />
              <Route
                exact
                path={routes.netProtectionV2Monitoring}
                element={
                  <MyPrivateRoute>
                    <MonitoringObjectsView />
                  </MyPrivateRoute>
                }
              />
              <Route
                exact
                path={routes.netProtectionV2Protected}
                element={
                  <MyPrivateRoute>
                    <ProtectedProfilesView />
                  </MyPrivateRoute>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </PageProvider>
        </Layout>
      </AppThemeProvider>
    </ThemeCustomization>
  );
};

export default App;
